"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var cookies_1 = require("../shared/cookies");
var messages_1 = require("../shared/messages");
(0, jquery_1.default)(function () {
    var key = "flash-message";
    var message = (0, cookies_1.getCookie)(key);
    if (!message) {
        return;
    }
    try {
        var decodedMessage = JSON.parse(message);
        var msg = decodedMessage.message;
        switch (decodedMessage.type) {
            case "error":
                (0, messages_1.showErrorMessage)(msg);
                break;
            default:
            case "success":
                (0, messages_1.showSuccessMessage)(msg);
                break;
        }
    }
    catch (e) {
        console.error(e);
    }
    (0, cookies_1.removeCookie)(key);
});
